import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { isTouch } from '../_app/cuchillo/core/Basics';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Header from '../layout/Header';
import Default from './Default';

export default class Project extends Default {
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor() {
    super();
  }

  beforeShow() {
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });

    Keyboard.mountPage(this.id);
    Header.sendUp();

    // if (this.isFirstTime) Header.selectPage();
  }
}

ControllerPage._addPage("project", Project);
